import axios, { ResponseType } from 'axios';
import { APP_CONFIG } from '@/config/app-config';
import authProvider from '@/utility/authProvider';

export default class HttpClient {
    public static instance(responseType?: ResponseType) {
        const baseURL = `${APP_CONFIG.baseDomain}/client`;
        const httpClient = axios.create({
            baseURL,
            headers: authProvider.isToken() ? {'Authorization': `Bearer ${authProvider.getToken()}` } : null,
            responseType
        });

        return httpClient;
    }
}